import { render, staticRenderFns } from "./usePie.vue?vue&type=template&id=7a28d4ec&scoped=true&"
import script from "./usePie.vue?vue&type=script&lang=js&"
export * from "./usePie.vue?vue&type=script&lang=js&"
import style0 from "./usePie.vue?vue&type=style&index=0&id=7a28d4ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a28d4ec",
  null
  
)

export default component.exports